import cx from 'classnames'
import { useEffect, useRef } from 'react'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'

import Loader from '../../../../components/Loader/Loader'
import HallLegend from '../HallLegend/HallLegend'
import GridAxes from './components/GridAxes/GridAxes'
import GridCaptions from './components/GridCaptions/GridCaptions'
import GridSeats from './components/GridSeats/GridSeats'
import Screen from './components/Screen/Screen'

import { useTransformComponentDimensions } from './hooks/useTransformComponentDimensions'

import hocConnect from './hocConnect'

import './HallSeating.scss'
import Entrances from './components/Entrances/Entrances'

import { getInitScale, getInitXPosition } from './helpers'

const HallSeating = ({ loadData, disable, data, error, loading, eventId, selectedSeats }) => {
    const wrapperRef = useRef(null)

    useEffect(() => {
        if (eventId && eventId !== 'undefined') {
            loadData({ eventId })
        }
    }, [eventId])

    const { maxSeatingChildrenX, maxSeatingChildrenY, scaleFactor, clientWidth, offsetX, offsetY } =
        useTransformComponentDimensions(data, wrapperRef)

    if (error) return null

    return (
        <>
            <div className={cx('hall-seating', disable && 'disable')} ref={wrapperRef}>
                <TransformWrapper
                    disabled={clientWidth > 1280 || loading}
                    doubleClick={{ disabled: true }}
                    minScale={0.4}
                    initialScale={getInitScale()}
                    initialPositionX={getInitXPosition()}
                    initialPositionY={0}
                    minPositionY={1}
                    maxPositionY={1}
                    wheel={{ step: 0.1 }}
                    disablePadding={true}
                    centerZoomedOut={true}
                    centerOnInit={false}
                >
                    <TransformComponent>
                        <div
                            className="content-wrapper"
                            style={{
                                width: `${maxSeatingChildrenX * scaleFactor + 48 + offsetX}px`,
                                height: `${maxSeatingChildrenY * scaleFactor + 128 + offsetY}px`,
                                minHeight: '200px',
                                minWidth: '200px',
                            }}
                        >
                            {loading ? (
                                <Loader />
                            ) : (
                                <>
                                    <Screen />
                                    <GridAxes
                                        data={data?.descriptions ?? []}
                                        scaleFactor={scaleFactor}
                                        maxSeatingChildrenX={maxSeatingChildrenX}
                                        offsetX={offsetX}
                                        offsetY={offsetY}
                                    />
                                    <GridSeats
                                        data={data?.seats ?? []}
                                        selectedSeats={selectedSeats ?? []}
                                        scaleFactor={scaleFactor}
                                        offsetX={offsetX}
                                        offsetY={offsetY}
                                    />
                                    <GridCaptions data={data?.descriptions ?? []} />

                                    <Entrances
                                        entrances={data?.entrances ?? []}
                                        scaleFactor={scaleFactor}
                                        offsetX={offsetX}
                                        offsetY={offsetY}
                                    />
                                </>
                            )}
                        </div>
                    </TransformComponent>
                </TransformWrapper>
            </div>
            {!!data?.seats?.length && <HallLegend seats={data?.seats ?? []} />}
        </>
    )
}

export default hocConnect(HallSeating)
